import { HttpError } from 'react-admin';

const handleError = (error, notify) => {

    if (error instanceof HttpError) {
        // Handle React Admin HttpError separately
        notify(error.message, { type: 'error' });
        return;
    }

    if (error.response && error.response.data && error.response.data.message) {
        {
            error.response.data.detail ? notify(`${error.response.data.message} : ${error.response.data.detail.errorMessage}`, { type: 'error' }) :
                notify(`${error.response.data.message}`, { type: 'error' })
        };
    }
    else throw new Error(error);
}

export default handleError;